'use strict';

sf.ready(function() {

    var slideInterview = document.querySelector('.m-slider-interview');
    new Slider(slideInterview);

    let tabs = new Tabs;

    let tab1 = new Tab(document.querySelector('.h-burger-mobile'));
    let tab2 = new Tab(document.querySelector('.m-menu-mobile'));

    let handler = (status, tab) => {

        let body = document.body;

        if (tab.isActive()) {

            body.classList.add('hidden')
            body.classList.remove('scroll');

        } else {

            body.classList.add('scroll')
            body.classList.remove('hidden');

        }

    };

    tab1.on('statusChange', handler);

    tab2.on('statusChange', handler);

    tabs.addTab(tab1);
    tabs.addTab(tab2);

});
